import { actionTypes } from 'actions/actionTypes'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const saveApplePayCheckoutToken: CheckoutActionCreator = (token: string) => ({
  type: actionTypes.SAVE_APPLE_PAY_CHECKOUT_TOKEN,
  token,
})
